export interface KbArticle {
  id: string;
  title: string;
  category: string;
  summary: string;
  body: string[];
}

export const KB_ARTICLES: KbArticle[] = [
  {
    id: 'kb_1',
    title: 'Como abrir um chamado',
    category: 'Primeiros passos',
    summary: 'Passo a passo para registrar um problema ou solicitação.',
    body: [
      'No menu lateral, acesse **Chamados** e clique em **Novo chamado**.',
      'Informe um assunto claro (mínimo 3 caracteres) e descreva o problema com detalhes.',
      'Escolha a prioridade adequada e envie o formulário.',
      'Você será redirecionado ao chamado criado, onde pode acompanhar status e conversar com o suporte.',
    ],
  },
  {
    id: 'kb_2',
    title: 'Entenda os status do ticket',
    category: 'Operação',
    summary: 'O que significa cada status no ciclo de vida do chamado.',
    body: [
      '**Aberto** — chamado registrado, aguardando triagem.',
      '**Em andamento** — um agente está trabalhando na resolução.',
      '**Em espera** — aguardando informação do solicitante ou terceiro.',
      '**Resolvido** — solução aplicada, pendente confirmação.',
      '**Fechado** — chamado encerrado.',
    ],
  },
  {
    id: 'kb_3',
    title: 'SLA e prazos de atendimento',
    category: 'Operação',
    summary: 'Como interpretar indicadores de SLA no detalhe do chamado.',
    body: [
      'O badge de SLA indica se o chamado está **no prazo**, em **atenção** ou **em risco**.',
      'Prioridades críticas e altas têm prazos menores de resposta.',
      'Agentes recebem alertas quando o SLA se aproxima do limite.',
    ],
  },
  {
    id: 'kb_4',
    title: 'Chat flutuante',
    category: 'Primeiros passos',
    summary: 'Envie mensagens sem sair da página de detalhe.',
    body: [
      'No canto inferior direito do detalhe do chamado, clique no botão amarelo de chat.',
      'Digite sua mensagem e envie. Agentes podem marcar **nota interna** visível só para a equipe.',
      'Todas as mensagens públicas aparecem também na timeline do chamado.',
    ],
  },
  {
    id: 'kb_5',
    title: 'Integração Slack',
    category: 'Integrações',
    summary: 'Receba alertas de chamados no Slack da sua organização.',
    body: [
      'Administradores acessam **Configurações → Integração Slack** e clicam em **Conectar Slack**.',
      'Autorize o workspace e escolha o canal de notificações.',
      'Novos chamados, comentários e mudanças de status são publicados no canal.',
      'Use o comando `/yhelp 1234` para consultar um chamado pelo número.',
    ],
  },
  {
    id: 'kb_6',
    title: 'Tour guiado',
    category: 'Primeiros passos',
    summary: 'Aprenda a usar a plataforma com o tour interativo.',
    body: [
      'No primeiro acesso, o tour inicia automaticamente com spotlight nos elementos principais.',
      'Clique no botão **?** no canto inferior esquerdo para refazer o tour a qualquer momento.',
      'Em **Configurações**, use **Refazer tour guiado** para repetir o passo a passo.',
    ],
  },
];

export function getKbArticle(id: string): KbArticle | undefined {
  return KB_ARTICLES.find((a) => a.id === id);
}
